module.exports = __webpack_public_path__ + "img/12.0a9b69fe.jpg";